<template>
  <div class="main">
    <back title="烘焙甜点订制班"></back>
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking1/banner.jpg"
    ></landingBanner>
    <div class="content">
      <footerForm color="#fff" bag="#a96b04" words="获取学费"></footerForm>
      <indexTitle title1="课程学习内容" title2="网红甜品课程 专业学习内容"></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="yellow">
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking1/part1-3.jpg"
            show-loading="false"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking1/part1-4.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking1/part1-1.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking1/part1-2.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
      </van-swipe>
      <find goto></find>

      <div style="width:100%;height:20px;"></div>
      <indexTitle title1="私人定制 走红秘籍" title2="为你量身订制精品课程"></indexTitle>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking1/part2.jpg">
        <template v-slot:loading>
          <van-loading size="30" />
        </template>
      </van-image>
      <div style="width:100%;height:20px;"></div>
      <indexTitle title1="我们的优势" title2="中外双师授课 百分百实操教学"></indexTitle>
      <advantage></advantage>
      <find></find>
      <div style="width:100%;height:20px;"></div>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking1/help.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div style="width:100%;height:20px;"></div>
      <indexTitle title1="成功创业学员" title2="迷茫的年纪，成功的选择"></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="red">
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking1/part3-1.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking1/part3-2.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
      </van-swipe>
      <find></find>
      <div style="width:100%;height:20px;"></div>
      <indexTitle title1="学员评价" title2="我们所有的努力只为了得到你们的认可"></indexTitle>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/dessert/talk.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div class="h20px" style="width:100%;height:20px;"></div>
      <indexTitle title1="创就业服务" title2="就业指导，创业帮扶"></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/baking9/logo.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
    </div>
    <div class="h25px" style="width:100%;height:22px;"></div>
    <footerForm color="#fff" bag="#a96b04" words="点击获取学费报价"></footerForm>
    <foot></foot>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {
    back: () => import("@/components/head/back"),
    landingBanner: () => import("@/components/common/landing-banner"),
    foot: () => import("@/components/foot/foot"),
    find: () => import("@/components/common/find"),
    advantage: () => import("@/components/common/advantage"),
    footerForm: () => import("@/components/form/footerForm"),
    indexTitle: () => import("@/components/common/indexTitle")
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
/deep/ .van-swipe__indicators{
  bottom: 15px;
    left: 10%;
}
.main {
  margin-top: 50px;
}
.content {
  padding: 10px;
}
</style>
